<div [appLoading]="this.isLoading" class="inline" *ngIf="formatters$ | async as formatter" id=this.chartId>
    <div fxLayout="column" class="form-group"  fxLayoutGap="40px" [hidden]="this.basicInfo.length == 0" >
      <h4 class="row">{{ this.chartTitle | translate }}</h4>
        <div fxLayout="column" class="form-group" style="height: 500px;">
          <div fxLayout="column wrap" fxLayoutGap="10px">
          <google-chart
              (ready)="onReady($event)"
              #chartOverview
              [type]="chartTypeChart"
              [data]="this.chartData"
              [columns]="this.columns"
              [width]="this.width"
              [height]="480"
              [options]="this.options"
              [dynamicResize]="true"
              [id]="this.chartId"
              ></google-chart>
          </div>
        </div>
    </div>
  
  </div>
